<template>
    <div class="list-header" :class="{ 'between':$slots.more || to }">
        <slot name="title">
            <span class="title">{{title}}</span>
        </slot>
        <span class="more" @click="() => { if(to) $router.push(to)}">
      <slot name="more">
        <img v-if="to" src="@/assets/images/more.svg">
      </slot>
    </span>
    </div>
</template>

<script>
    export default {
        name: "Head",
        props: {
            title: String,
            to: Object,
        },
        data() {
            return {}
        },
        created() {

        },
        mounted() {

        },
        methods: {}
    }
</script>

<style lang="less" scoped>

</style>